import { createSlice } from "@reduxjs/toolkit";
interface types {
  tokenList: any[];
  isLoading: boolean;
  allTomanMarket: any[];
  allTetherMarket: any[];
  pairName: string;
  isRefresh: boolean;
}
const initialState: types = {
  tokenList: [],
  isLoading: true,
  allTomanMarket: [],
  allTetherMarket: [],
  pairName: "",
  isRefresh: false,
};
const tokenSlice = createSlice({
  name: "bestPriceCoins",
  initialState,
  reducers: {
    bestPriceCoins: (state) => ({ ...state }),
    setCoins(state, { payload }) {
      state.allTomanMarket = [];
      state.allTetherMarket = [];
      state.tokenList = payload.response;
      state.isLoading = false;
      for (let element of state.tokenList) {
        const [, pairName] = element.pair.split("/");
        if (pairName === "TMN") {
          state.allTomanMarket.push(element);
        } else {
          state.allTetherMarket.push(element);
        }
      }
    },
    setRefresh(state, { payload }) {
      state.isRefresh = payload;
    },
  },
});

export const { bestPriceCoins, setCoins, setRefresh } = tokenSlice.actions;

export default tokenSlice.reducer;
